export default __webpack_public_path__ + "static/media/downarrow.616a5b5e.png";